// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"a28af603","544":"fa82c02b","584":"69892d0b","600":"5ba94b65"}[chunkId] + ".chunk.js";
};